import React from "react";
import axios from "axios";
import { api } from "./api/client";
import MUIDataTable from "mui-datatables";
import {createTheme, MuiThemeProvider} from "@material-ui/core/styles";
import {utils, write} from "xlsx";
import { saveAs } from 'file-saver'
import moment from "moment";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import Select from "react-select";
import {adaptV4Theme} from "@mui/material/styles";
import { enhanceColumns, withTableOptions } from "./utils/tableDisplay";
const styles = {
    option: (provided, state) => ({
        ...provided,
        color: state.isSelected ? 'orange' : 'gray',

        lineHeight: 1
    }),
    control: () => ({
        // none of react-select's styles are passed to <Control />
        position:'relative',
        width: 200,
        lineHeight: 1
    }),

}
class ExpandableRowEntry extends React.Component {
    rows;
    lokasyonlarRows;
    technologyList = [];
    customerList =  [];

    constructor(props) {
        super(props);
        this.state={childRows:[], childRowId:0,locations:[], locationChangeOpen:false,customerChangeOpen:false
            ,customerID:0,locationID:0,machineID:0, selected: null};
        this.getDatas();
        this.getCustomerList();
    }

     changeLocationConfirm = (locationID,machineID) => {
       this.setState({locationChangeOpen:true,locationID:locationID,machineID:machineID});
    };

    changeCustomerConfirm = (customerID,machineID) => {
        this.setState({customerChangeOpen:true,customerID:customerID,machineID:machineID});
    };

    locationChangeClose = () => {
         this.setState({locationChangeOpen:false,locationID:0,machineID:0});
     };

    customerChangeClose = () => {
        this.setState({customerChangeOpen:false,customerID:0,machineID:0});
    };

    async getDatas() {

        const lokasyonID = this.props.rowData[0];
        const row = await api.get('/lookups/makineler', {
            params: {
                lokasyon_id: lokasyonID
            }
        });

        //console.log(JSON.parse(JSON.stringify((Array.isArray(row.data)?row.data:(row.data?.data||[])))));
        this.rows=(Array.isArray(row.data)?row.data:(row.data?.data||[]));

        const machines = this.rows.map(d => ({
            "lokasyon_id":d.lokasyon_id ,
            "id": d.id,
            "makine" :  d.makine,
            "makine_adet":d.makine_adet ,
            "cikis_tarihi":d.cikis_tar,
            "kurulum_tarihi": d.kurulum_tar,
            "siparis_no" :  d.siparis_no,
            "seri_no": d.seri_no,
            "musteri_id" :  d.musteri_id,
        }))
        //console.log(products);
        this.setState({childRows: machines})


               // for machine location update
               const lokasyonlars = await api.get('/lookups/lokasyonlar', {
                   params: {
                       musteri_id:machines[0].musteri_id
                }
               } );

               this.lokasyonlarRows=(Array.isArray(lokasyonlars.data)?lokasyonlars.data:(lokasyonlars.data?.data||[]));
               this.technologyList =[];
               const locations = this.lokasyonlarRows.map(d => (
                   this.technologyList.push({
                       label: d.lokasyon_adi,
                       value: d.lokasyon_id
                   })
               ))

               await this.setState({locations: (Array.isArray(lokasyonlars.data)?lokasyonlars.data:(lokasyonlars.data?.data||[]))})
               console.log("location",this.state.locations);
    }

    async getCustomerList() {
        const row = await api.get('/lookups/musteriler', { params: { limit: 10000 } });
        //console.log(JSON.parse(JSON.stringify((Array.isArray(row.data)?row.data:(row.data?.data||[])))));
        this.rows=(Array.isArray(row.data)?row.data:(row.data?.data||[]));

        const customers = this.rows.map(d => (
            this.customerList.push({
                label: d.firma,
                value: d.musteri_id
            })
        ))
    }

    async changeLocation(locationID, machineID) {

        await api.post(`/lookups/makineler/${machineID}/lokasyon`, null, { params: {
                lokasyon_id: locationID,
                makine_id: machineID
            } })
            .then((response) => {
                // Success 🎉
                console.log(response);
                this.getDatas();
                this.locationChangeClose();

            })
            .catch((error) => {
                // Error 😨
                if (error.response) {
                    /*
                     * The request was made and the server responded with a
                     * status code that falls out of the range of 2xx
                     */
                    console.log(error.response.data);
                    console.log(error.response.status);
                    console.log(error.response.headers);
                } else if (error.request) {
                    /*
                     * The request was made but no response was received, `error.request`
                     * is an instance of XMLHttpRequest in the browser and an instance
                     * of http.ClientRequest in Node.js
                     */
                    console.log(error.request);
                } else {
                    // Something happened in setting up the request and triggered an Error
                    console.log('Error', error.message);
                }
                console.log(error.config);
            });

    }
    async changeCustomer(musteriID, machineID) {

        await api.post(`/lookups/makineler/${machineID}/musteri`, null, {
            params: {
                musteri_id: musteriID,
                makine_id: machineID
            }
        })
            .then((response) => {
                // Success 🎉
                console.log(response);
                this.getDatas();
                this.customerChangeClose()
            })
            .catch((error) => {
                // Error 😨
                if (error.response) {
                    /*
                     * The request was made and the server responded with a
                     * status code that falls out of the range of 2xx
                     */
                    console.log(error.response.data);
                    console.log(error.response.status);
                    console.log(error.response.headers);
                } else if (error.request) {
                    /*
                     * The request was made but no response was received, `error.request`
                     * is an instance of XMLHttpRequest in the browser and an instance
                     * of http.ClientRequest in Node.js
                     */
                    console.log(error.request);
                } else {
                    // Something happened in setting up the request and triggered an Error
                    console.log('Error', error.message);
                }
                console.log(error.config);
            });

    }

    render() {
        let datas=[];
        let data= this.state.childRows;
        const {selected} = this.state;
        const options = {
            filter: false,
            onFilterChange: (changedColumn, filterList) => {
                //console.log(changedColumn, filterList);
            },
            selectableRows: false,
            filterType: 'multiselect',
            responsive: "vertical",
            rowsPerPage: 100,
            fixedHeader: true,
            //fixedSelectColumn: true,
            tableBodyHeight: '100%',
            print:false,
            download:true,
            draggableColumns: {
                enabled:false,
                transitionTime:400
            },
            rowStyle: {
                fontSize: 8,
            },
            downloadOptions: {
                filterOptions: {
                    useDisplayedColumnsOnly: true,
                    useDisplayedRowsOnly: true
                }
            },
            onRowSelectionChange : (curRowSelected, allRowsSelected) => {
                datas.length=0;
                console.log("---RowSelect")
                console.log("Row Selected: ", curRowSelected);
                console.log("All Selected: ", allRowsSelected);

                if(allRowsSelected) {
                    allRowsSelected.forEach((result)=>{
                        datas.push(this.state.childRows[result.dataIndex]);
                    })
                }
            },
            textLabels :{
                selectedRows: {
                    text: "satır seçildi",
                    delete: "SiparişeEkle",
                    deleteAria: "Seçilenleri siparişe aktar",
                },
                pagination: {
                    next: "İleri",
                    previous: "Geri",
                    rowsPerPage: "Sayfadaki satır sayısı:",
                    displayRows: "/",
                },
                toolbar: {
                    search: "Ara",
                    downloadCsv: "XLSX İndir",
                    print: "Çıktı Al",
                    viewColumns: "Sütunları Göster",
                    filterTable: "Tabloyu Süz",
                },
                filter: {
                    all: "Tümünü Göster",
                    title: "Filtreler",
                    reset: "Sıfırla",
                },
                viewColumns: {
                    title: "Sütunları Göster",
                    titleAria: "Sütunları Göster/Gizle",
                },

            },
            onDownload: (buildHead, buildBody, columns, values) => {
                const fileType =
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
                const fileExtension = ".xlsx";

                //console.log(values.forEach(val => console.log(val)));

                const json = values.reduce((result, val) => {
                    const temp = {};
                    val.data.forEach((v, idx) => {
                        temp[columns[idx].name] = v;
                    });
                    result.push(temp);
                    return result;
                }, []);

                const fileName = `Makine Listesi`;
                const ws = utils.json_to_sheet(json);
                const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
                const excelBuffer = write(wb, { bookType: "xlsx", type: "array" });
                const data = new Blob([excelBuffer], { type: fileType });
                saveAs(data, fileName + fileExtension);
                // cancel default  CSV download from table
                return false;
            },
            expandableRows: false,


        };

            const myTheme  = createTheme(adaptV4Theme({

                overrides: {
                 MUIDataTableToolbar:{
                    root:{
                        display: "none"
                    }
                },
                MUIDataTableFooter:{
                    root:{
                        display: "none"
                    }
                },
                MUIDataTableHeadCell:{
                   root: {



                    }},
                MuiTableCell: {
                    head: {
                        backgroundColor: "#e3a165 !important",
                        fontWeight: "bold",
                        padding:1,
                        lineHeight:0.1,
                        width: '370px'
                    },

                    root: {


                    }
                },
                MUIDataTable: {

                    responsiveScroll: {
                        minHeight:'30vh',
                        width:'1200px'
                    },

                },
            },
        }));

        const columns = [

            {
                name: "seri_no",
                label:"Seri No",
                options: {
                    filter:false,
                    sort:false,
                }
            },
            {
                name: "siparis_no",
                label: "UYF No",
                options: {
                    filter: false,
                    customBodyRender: (value, meta, updateValue) => {
                        const record = data[meta.currentTableData[meta.rowIndex].index];
                            return (
                                <a href={'http://coiltech.biz/pdfer/uyf.php?id='+record.id} target={'_blank'} rel={'noreferrer'}> {value} </a>
                            );

                    },
                },
            },
            {
                name: "makine",
                label: "Makine",
                options: {
                    filter: true,
                    filterOptions: {
                        fullWidth: true
                    }
                },
            },
            {
                name: "makine_adet",
                label: "Adet",
                options: {
                    filter: false,

                }
            },
            {
                name: "cikis_tarihi",
                label: "Çıkış Tarihi",
                options: {
                    filter: false,
                    customBodyRender: value =>
                        moment(new Date(value)).format('d/MM/Y')

                }
            },
            {
                name: "kurulum_tarihi",
                label: "Kuruluş Tarihi",
                options: {
                    filter: false,
                    customBodyRender: value =>
                        moment(new Date(value)).format('d/MM/Y')
                }
            },
            {
                name: "id",
                label: "Müşteri Seç",
                options: {
                    filter: false,
                    customBodyRender: (value, tableMeta, updateValue) => {

                        return (
                            <Select options={this.customerList}    value={selected}       styles={styles}
                                    onChange={event => this.changeCustomerConfirm(event.value,value)}

                            />
                        );
                    },

                },
            },
            {
                name: "id",
                label: "Lokasyon Seç",
                options: {
                    filter: false,
                    customBodyRender: (value, tableMeta, updateValue) => {

                        return (
                            <Select options={ this.technologyList }  value={selected}  styles={styles}
                                    onChange={event => this.changeLocationConfirm(event.value,value)}

                            />
                        );
                    },

                }
            },
        ];

        return(

            <React.Fragment>

                <Dialog
                    open={this.state.locationChangeOpen}
                    onClose={this.locationChangeClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {"Lokasyonu değiştirme onayı"}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Bu makinenin lokasyonunu değiştirmek istediğinizden emin misiniz?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.locationChangeClose}>İptal</Button>
                        <Button onClick={()=>{this.changeLocation(this.state.locationID, this.state.machineID).then((r) => console.log(r))}}>
                            Lokasyonu Değiştir
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={this.state.customerChangeOpen}
                    onClose={this.customerChangeClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {"Müşteriyi değiştirme onayı"}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Bu makinenin müşterisini değiştirmek istediğinizden emin misiniz?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.customerChangeClose}>İptal</Button>
                        <Button onClick={()=>{this.changeCustomer(this.state.customerID, this.state.machineID).then((r) => console.log(r))}}>
                            Müşteriyi Değiştir
                        </Button>
                    </DialogActions>
                </Dialog>


                <tr>
                <td colSpan={9}>
                    <MuiThemeProvider theme={myTheme}>
                        <MUIDataTable title={"Makineler"} data={this.state.childRows} columns={enhanceColumns(columns)} options={withTableOptions(options)} />
                    </MuiThemeProvider>
                </td>
            </tr>

        </React.Fragment> )

    };

};

export default ExpandableRowEntry;
